import { render, staticRenderFns } from "./storeaddress-list.vue?vue&type=template&id=e1888c90&"
import script from "./storeaddress-list.vue?vue&type=script&lang=ts&"
export * from "./storeaddress-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports